import React from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { tabStyle } from "./tab.style";

const CustomTabs = ({ tabOptions, value, tabChangeHandler }) => {
  const classes = tabStyle(this);
  const handleChange = (event, newValue) => tabChangeHandler(newValue);

  return (
    <>
      <Tabs className={classes.tabs} value={value} onChange={handleChange}>
        {tabOptions.map((tabVal, index) => (
          <Tab
            key={index}
            value={index}
            label={
              <div className={classes.badgeContainer}>
                <label className="tab__title">{tabVal.tabval}</label>
                {tabVal.count?.toString() && <span className={classes.badge}>{tabVal.count}</span>}
              </div>
            }
          />
        ))}
      </Tabs>
    </>
  );
};

export default CustomTabs;
